export default {
    name: 'login',
    path: '/login',
    component: () => import(`./index.vue`),
    meta: {
        skip_check_token: true,
        footer_margin_none: true,
    },
};
